import vxlColors from 'shared/styles/color/core';

const interactive = {
  primary: vxlColors.core.purple[500],
  primaryHovered: vxlColors.core.purple[600],
  primaryPressed: vxlColors.core.purple[700],
  secondary: vxlColors.core.neutrals.white,
  secondaryHovered: vxlColors.core.neutrals.grey[200],
  secondaryPressed: vxlColors.core.neutrals.grey[300],
  tertiary: vxlColors.core.neutrals.grey[200],
  tertiaryHovered: vxlColors.core.neutrals.grey[300],
  tertiaryPressed: vxlColors.core.neutrals.grey[400],
  inverse: vxlColors.core.neutrals.white,
  inverseHovered: `${vxlColors.core.neutrals.white}eb`,
  inversePressed: `${vxlColors.core.neutrals.white}d6`,
  black: vxlColors.core.neutrals.black,
  blackHovered: `${vxlColors.core.neutrals.black}e0`,
  blackPressed: `${vxlColors.core.neutrals.black}cc`,
  surface: vxlColors.core.neutrals.grey[100],
  surfaceHovered: vxlColors.core.neutrals.grey[200],
  surfacePressed: vxlColors.core.neutrals.grey[300],
  focused: {
    border: vxlColors.core.purple[900],
  },
  disabled: {
    background: vxlColors.core.neutrals.grey[200],
    text: vxlColors.core.neutrals.grey[400],
    border: vxlColors.core.neutrals.grey[400],
  },
};

export default interactive;
